/* eslint-disable react-native/no-color-literals */
import { StyleSheet } from "react-native"

export const style = StyleSheet.create({
  container: { flexDirection: "row", marginVertical: 4 },
  radioButton: {
    alignItems: "center",
    borderColor: "#E6E6E6",
    borderRadius: 10,
    borderWidth: 1,
    height: 20,
    justifyContent: "center",
    marginRight: 5,
    width: 20,
  },
  radioButtonIcon: {
    borderRadius: 7,
    height: 14,
    width: 14,
  },
})
